import { GenIcon } from '../helpers/IconBase.es.js';

const MinusRetangleOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75 7C3.75 5.20507 5.20507 3.75 7 3.75H17.5C19.2949 3.75 20.75 5.20507 20.75 7V17.5C20.75 19.2949 19.2949 20.75 17.5 20.75H7C5.20507 20.75 3.75 19.2949 3.75 17.5V7ZM7 2.25C4.37665 2.25 2.25 4.37665 2.25 7V17.5C2.25 20.1234 4.37665 22.25 7 22.25H17.5C20.1234 22.25 22.25 20.1234 22.25 17.5V7C22.25 4.37665 20.1234 2.25 17.5 2.25H7ZM7.90216 11.5C7.48795 11.5 7.15216 11.8358 7.15216 12.25C7.15216 12.6642 7.48795 13 7.90216 13H16.5978C17.012 13 17.3478 12.6642 17.3478 12.25C17.3478 11.8358 17.012 11.5 16.5978 11.5H7.90216Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { MinusRetangleOutlined };
